import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Stable } from '@tcc-mono/vandijk/shared/data-access/models';
import { StableService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StableRepository extends CoreRepository<Stable> {

  public stables$: Observable<Stable[]> = this.entities$;
  public selectedStable$: Observable<Stable> = this.activeEntity$;

  public constructor(
    protected readonly _stableService: StableService
  ) {
    super(
      { name: 'stables' },
      _stableService
    )
  }

  public addStable = (stable: Partial<Stable>): Observable<Stable> => {
    return this.addEntity(stable);
  }

  public updateStable = (stableId: number, stable: Stable): Observable<Stable> => {
    return this.updateEntity(stableId, stable);
  }

  public getStable = (stableId: number): Observable<Stable> => {
    return this.getEntity(stableId);
  }

  public removeStable = (stableId: number): Observable<unknown> => {
    return this.removeEntity(stableId);
  }

  public setActiveStable = (stableId: number): void => {
    this.setActiveEntity(stableId);
  }
}
